import { useEffect, useState } from "react";
import { useMatches } from "react-router-dom";
import type { ProfessionalsLoaderData } from "./Professionals";
import { fetchProfessionalsCatalogs } from "./professionalsCatalog";

const EMPTY: ProfessionalsLoaderData = {
  offices: [],
  dataAdmin: [],
  firmContact: [],
  officeMainContacts: [],
};

export function useProfessionalsCatalogData(firmId: string | undefined) {
  const matches = useMatches();
  const loaderData = matches.reduce<ProfessionalsLoaderData | undefined>(
    (found, match) => {
      if (found) {
        return found;
      }
      const data = match.data as ProfessionalsLoaderData | undefined;
      if (data && Array.isArray(data.offices)) {
        return data;
      }
      return undefined;
    },
    undefined,
  );

  const [fetchedData, setFetchedData] =
    useState<ProfessionalsLoaderData | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (loaderData || !firmId) {
      setFetchedData(null);
      setLoading(false);
      return;
    }

    let cancelled = false;
    setLoading(true);

    void fetchProfessionalsCatalogs(firmId)
      .then((data) => {
        if (!cancelled) {
          setFetchedData(data);
        }
      })
      .catch((err) => {
        console.error("useProfessionalsCatalogData", err);
        if (!cancelled) {
          setFetchedData(EMPTY);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [loaderData, firmId]);

  const catalogData = loaderData ?? fetchedData ?? EMPTY;

  return {
    catalogData,
    loading: !loaderData && loading && Boolean(firmId),
  };
}
